import { createSlice } from "@reduxjs/toolkit";

const authInitialState = { isAuthenticated: false, user: null, initialUrl: '/dashboard' }

const authSlice = createSlice({
    name: 'auth',
    initialState: authInitialState,
    reducers: {
        isAuthenticated: (state, action) => {
            console.log('isAuth action fun', action.payload)
            state.isAuthenticated = action.payload;
        },
        setUserProflie: (state, action) => {
            state.user = action.payload;
        },
        setInitialUrl: (state, action) => {
            state.initialUrl = action.payload;
        },
        logout: (state) => {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            state.isAuthenticated = false;
            state.user = null;
        }
    }
})

export const authActions = authSlice.actions;

export default authSlice.reducer;